import React, { Fragment, Component } from 'react';
import styled from 'styled-components';
import { Flex, Box, Link } from 'rebass';
import { Modal, Button } from 'semantic-ui-react';
import { Form, Checkbox } from 'formsy-semantic-ui-react';

import { Text } from '../Base';
import { SPACE, FONT_SIZE, COLOR } from '../Theme';

import AddExamErrorModal from './AddExamErrorModal';

const SCheckbox = styled(Checkbox)`
  label::before {
    width: 25px !important;
    height: 25px !important;
  }
  label::after {
    margin-top: ${SPACE.xmall} !important;
    font-size: 25px !important;
  }
  label {
    line-height: 1.75em;
    padding-left: 2.5em !important;
  }
`;

class AddExamsList extends Component {
  state = {
    openErrorModal: false,
  };
  componentDidUpdate = prevProps => {
    if (prevProps.displayError === false && this.props.displayError === true) {
      this.openErrorModal();
    }
  };

  handleSubmit = form => {
    this.props.onSubmit(form);
  };

  openErrorModal = () => {
    this.setState({
      openErrorModal: true,
    });
  };

  closeErrorModal = () => {
    this.setState({
      openErrorModal: false,
    });
  };

  render() {
    const { exams, onCloseModal } = this.props;
    const { openErrorModal } = this.state;

    return (
      <Fragment>
        <Modal.Header>เพิ่มวิชาสอบ</Modal.Header>
        <Form onValidSubmit={this.handleSubmit}>
          <Modal.Content scrolling>
            <Box ml={SPACE.large} mt={SPACE.small}>
              {exams &&
                exams.map((exam, index) => {
                  return (
                    <Box key={index} pb={SPACE.medium}>
                      <SCheckbox name={exam.subjectCode} label={exam.subjectName} />
                    </Box>
                  );
                })}
            </Box>
          </Modal.Content>
          <Flex justifyContent="flex-end" alignItems="center" p={SPACE.medium}>
            <Button
              onClick={onCloseModal}
              basic
              circular
              style={{
                minWidth: '100px',
                backgroundColor: '#ffffff',
                border: '#9b9b9b',
              }}
            >
              <Text is="span" fontWeight="500" fontSize={FONT_SIZE.small}>
                ยกเลิก
              </Text>
            </Button>
            <Button
              type="submit"
              primary
              circular
              style={{
                minWidth: '100px',
              }}
            >
              <Text is="span" fontWeight="500" fontSize={FONT_SIZE.small} color={COLOR.white}>
                เพิ่มวิชาสอบ
              </Text>
            </Button>
          </Flex>
        </Form>
        <AddExamErrorModal open={openErrorModal} onClose={this.closeErrorModal} />
      </Fragment>
    );
  }
}

export default AddExamsList;
